import { getApiClient, type RequestOpts } from './api-client';
import { HUB_SERVICE_URL as servicePath } from '../constants/APIconstants';
import type { AnswerSourceItem } from '../panda/messages/doc-answer';

/**
 * The hub copy of a knowledge item. The hub twin reuses the source item's `_id`,
 * so an answer's `document_id` addresses the hub copy directly. Only the source
 * fields the answer card needs are typed here.
 */
export type HubKnowledgeItem = AnswerSourceItem & { id?: string };

// Hub endpoints on the react-query api-client; the legacy Executer-based
// endpoints live in hub.service.api.js.
class HubRqService {
  // Goes through the hub-access policy, so it resolves cross-org where the
  // caller's own knowledge store can't.
  getItem(id: string, { signal }: RequestOpts = {}): Promise<HubKnowledgeItem> {
    return getApiClient().get<HubKnowledgeItem>(`${servicePath}items/${id}`, { signal });
  }
}

export default new HubRqService();
